/** @type {import('Simple/types.js').useDataConfiguration} */
import formatISO from 'date-fns/formatISO'
import addDays from 'date-fns/addDays'
import endOfMonth from 'date-fns/endOfMonth'
import { useDataValue } from 'Simple/Data.js'

let DEFAULT_MEDICAL_PLAN = 'PRIVATE_INSURANCE'

function getFirstAndLastDay(date, offset = 0) {
  let month = date.getMonth()
  let year = date.getFullYear()
  // always start from the first
  // unless it's the same month
  let day = 1

  let currentDate = new Date()

  if (month === currentDate.getMonth()) {
    day = addDays(date, offset).getDate()
  }

  let firstDay = new Date(year, month, day)

  return {
    from: formatISO(firstDay, { representation: 'date' }),
    until: formatISO(endOfMonth(firstDay), { representation: 'date' }),
  }
}

export default function useDataConfiguration(props) {
  let answer = useDataValue({
    context: 'selected',
    viewPath: props.viewPath,
    path: 'answers',
  })

  let settings = useDataValue({
    context: 'widget',
    viewPath: props.viewPath,
    path: 'settings',
  })

  let appointmentSlotOffsetDays = useDataValue({
    context: 'widget',
    path: 'settings.appointmentSlotOffsetDays',
    viewPath: props.viewPath,
  })

  let selectedSlotMonth = useDataValue({
    context: 'selected_slot',
    viewPath: props.viewPath,
    path: 'month',
  })

  let settingsInsurance = useDataValue({
    viewPath: props.viewPath,
    context: 'widget',
    path: 'settings.defaultInsurance',
  })

  let locationVisitType = useDataValue({
    context: 'selected',
    viewPath: props.viewPath,
    path: 'answers.location.locationVisitType',
  })

  let locationVisitTypeSettings = useDataValue({
    viewPath: props.viewPath,
    context: 'widget',
    path: 'settings.appointmentTypes',
  })

  let offset = appointmentSlotOffsetDays > 0 ? appointmentSlotOffsetDays : 0

  let { from, until } = getFirstAndLastDay(
    selectedSlotMonth || new Date(),
    offset
  )

  let location_id =
    parseInt(answer.location?.id, 10) || settings?.location_numeric_id

  let insurance =
    answer.insurance?.value || settingsInsurance || DEFAULT_MEDICAL_PLAN

  if (!locationVisitType) {
    locationVisitType = locationVisitTypeSettings?.Virtual
      ? 'virtual'
      : 'in_person'
  }

  return {
    variables: {
      from,
      until,
      location_id,
      // if no location question is present, then use the default settings
      medical_plan: locationVisitType
        ? `${insurance.toUpperCase().replace('_VIRTUAL', '')}${
            locationVisitType === 'virtual' ? '_VIRTUAL' : ''
          }`
        : insurance.toUpperCase(),
    },
    pause: !location_id || !insurance,
  }
}
